export const ru = {
    'are-you-sure-to-apply-many-items':
        'Вы уверены, что хотите применить рекомендацию для {count} объектов?',
    'are-you-sure-to-apply-one-item':
        'Вы уверены, что хотите применить рекомендацию для {count} объекта?',
    'are-you-sure-to-apply-some-items':
        'Вы уверены, что хотите применить рекомендацию для {count} объектов?',
    'error-refresh': 'Возникла ошибка. Попробуйте обновить страницу.',
    'try-later':
        'При применении рекомендации возникла ошибка. Попробуйте ещё раз.'
};
